import { createApp } from 'vue'
import App from './App.vue'

createApp(App).mount('#app')

// Registro del service worker (PWA). Solo en producción para no interferir
// con el hot-reload del dev server.
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    const base = process.env.BASE_URL || '/'
    navigator.serviceWorker.register(`${base}service-worker.js`).catch(() => {})
  })
}
